var map = {
	"./blackGold/header/shareIcon.png": 86021,
	"./brownGold/header/shareIcon.png": 44204,
	"./darkBlue/header/shareIcon.png": 52609,
	"./greenYellow/header/shareIcon.png": 15585,
	"./redGold/header/shareIcon.png": 4273,
	"./skyBlue/header/shareIcon.png": 7132,
	"./whiteGold/header/shareIcon.png": 15820,
	"./yellowWhite/header/shareIcon.png": 10438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23940;